import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const Subtitle = styled(Typography)({
	alignSelf: 'flex-start',
	fontWeight: 600,
	fontFamily: 'MuseoSansCyrl',
});

export const Grid = styled(Box)({
	display: 'grid',
	gridTemplateColumns: 'repeat(3, 1fr)',
	gridTemplateRows: 'repeat(6, max-content)',
	gap: 1,
	marginBottom: 1,
});
